import { Link } from 'react-router-dom';
import { useTranslation } from '../../../utils/useTranslation';
import { Button } from '../../input/Button';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { BusinessStatisticInfo } from '../BusinessStatisticInfo/BusinessStatisticInfo';
import { MORE_URL } from './constants';
import { StatisticContent } from './parts/StatisticContent/StatisticContent';
import { StatisticInfo } from './parts/StatisticInfo/StatisticInfo';
import { BusinessStatisticProps } from './types';

export const BusinessStatistic = (props: BusinessStatisticProps) => {
    const t = useTranslation();
    const { statistic, statisticUrl, statisticLoading, onAllStatisticClick, isService, ...other } =
        props;

    const title = t('Статистика');

    return (
        <Box py={1} px={{ xs: 2, sm: 3 }} pb={3} {...other}>
            <Flex width="100%" borderRadius={2}>
                <Flex
                    width="100%"
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Box pt={1.25} pb={0.25}>
                        <Flex direction="row" spacing={0} alignItems="center">
                            <Typography variant="body" weight="bold">
                                {title}
                            </Typography>
                            <BusinessStatisticInfo
                                ml={-0.5}
                                title={title}
                                moreUrl={MORE_URL}
                                statisticUrl={statisticUrl}
                                onAllStatisticClick={onAllStatisticClick}
                            >
                                <StatisticInfo />
                            </BusinessStatisticInfo>
                        </Flex>
                    </Box>
                    <Button
                        as={Link}
                        size="xs"
                        color="secondary"
                        to={statisticUrl}
                        onClick={onAllStatisticClick}
                    >
                        {t('Вся статистика')}
                    </Button>
                </Flex>
                <StatisticContent
                    statisticLoading={statisticLoading}
                    statistic={statistic}
                    isService={isService}
                />
            </Flex>
        </Box>
    );
};
